export enum WaterPipePressureModel {
  HOMOGENEOUS = 'Homogeneous',
}
